module.exports = __webpack_public_path__ + "static/normal-a-639428cf065384aae22d01b529011992.jpg";